var map = {
	"./bells.png": "6625",
	"./clay.png": "2dfc",
	"./gold-nugget.png": "8643",
	"./hardwood.png": "f916",
	"./iron-nugget.png": "73e8",
	"./softwood.png": "6322",
	"./stone.png": "c9a4",
	"./wood.png": "6180"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7504";